<template>
  <div v-if="pc" class="acn_head mw1200">
    <div class="logo" to="/home">
      <router-link :class="{'pen': $route.path ==='/'}" to="/home" style="margin-right: 10px">
        <img src="@/assets/logo.png" />
      </router-link>
      <img v-if="isEn" src="@/assets/word.png" />
      <img v-else src="@/assets/word2.png" />
    </div>
    <a-menu class="menu" :selectedKeys="selectedKeys" mode="horizontal">
      <a-menu-item :class="{'pen': $route.path ==='/'}" key="/projects">
        <router-link to="/projects">
          <span>{{$t('menu.projects')}}</span>
        </router-link>
      </a-menu-item>
      <a-menu-item class="pen">|</a-menu-item>
      <a-menu-item :class="{'pen': $route.path ==='/'}" key="/viewpoints">
        <router-link to="/viewpoints">
          <span>{{$t('menu.viewpoints')}}</span>
        </router-link>
      </a-menu-item>
      <a-menu-item class="pen">|</a-menu-item>
      <a-menu-item :class="{'pen': $route.path ==='/'}" key="/publications">
        <router-link to="/publications">
          <span>{{$t('menu.publications')}}</span>
        </router-link>
      </a-menu-item>
      <a-menu-item class="pen">|</a-menu-item>
      <a-menu-item :class="{'pen': $route.path ==='/'}" key="/events">
        <router-link to="/events">
          <span>{{$t('menu.events')}}</span>
        </router-link>
      </a-menu-item>
      <a-menu-item class="pen">|</a-menu-item>
      <a-menu-item :class="{'pen': $route.path ==='/'}" key="/country">
        <router-link to="/country">
          <span>{{$t('menu.country')}}</span>
        </router-link>
      </a-menu-item>
      <a-menu-item class="pen">|</a-menu-item>
      <a-menu-item :class="{'pen': $route.path ==='/'}" key="/services">
        <router-link to="/services">
          <span>{{$t('menu.services')}}</span>
        </router-link>
      </a-menu-item>
      <a-menu-item class="pen">|</a-menu-item>
      <a-menu-item :class="{'pen': $route.path ==='/'}" key="/company">
        <router-link to="/company">
          <span>{{$t('menu.company')}}</span>
        </router-link>
      </a-menu-item>
    </a-menu>
    <a-select :defaultValue="locale" style="width: 100px;bottom: 15px;font-size: 16px;right: 0;position: absolute" @select="select">
      <a-select-option value="en-US" style="font-size: 15px">English</a-select-option>
      <a-select-option value="zh-CN" style="font-size: 13px">简体中文</a-select-option>
    </a-select>
  </div>
  <div v-else>
    <div v-show="show" style="position: fixed;z-index: 10;background: white;width: 100%">
      <div style="display: flex;justify-content: space-between;margin: 20px;font-size: 50px">
        <a-icon type="bank" @click="home" />
        <a-icon type="close" @click="show = false" />
      </div>
      <a-menu class="menu" :selectedKeys="selectedKeys" @click="show = false">
        <a-menu-item key="/projects">
          <router-link style="padding-left: 4px" to="/projects">
            <span class="f20">{{$t('menu.projects')}}</span>
          </router-link>
        </a-menu-item>
        <a-menu-item key="/viewpoints">
          <router-link style="padding-left: 4px" to="/viewpoints">
            <span class="f20">{{$t('menu.viewpoints')}}</span>
          </router-link>
        </a-menu-item>
        <a-menu-item key="/publications">
          <router-link style="padding-left: 4px" to="/publications">
            <span class="f20">{{$t('menu.publications')}}</span>
          </router-link>
        </a-menu-item>
        <a-menu-item key="/events">
          <router-link style="padding-left: 4px" to="/events">
            <span class="f20">{{$t('menu.events')}}</span>
          </router-link>
        </a-menu-item>
        <a-menu-item key="/country">
          <router-link style="padding-left: 4px" to="/country">
            <span class="f20">{{$t('menu.country')}}</span>
          </router-link>
        </a-menu-item>
        <a-menu-item key="/services">
          <router-link style="padding-left: 4px" to="/services">
            <span class="f20">{{$t('menu.services')}}</span>
          </router-link>
        </a-menu-item>
        <a-menu-item key="/company">
          <router-link style="padding-left: 4px" to="/company">
            <span class="f20">{{$t('menu.company')}}</span>
          </router-link>
        </a-menu-item>
      </a-menu>
      <div style="background: #cccccc;padding: 10px 20px;font-size: 20px">
        <span style="margin-right: 15px" @click="select('en-US')">English</span>|<span style="margin-left: 15px" @click="select('zh-CN')">中文</span>
      </div>
    </div>
    <div style="display: flex;justify-content: space-between;align-items: center">
      <div>
        <router-link :class="{'pen': $route.path ==='/'}" to="/home">
          <img src="@/assets/logo.png" />
        </router-link>
        <img v-if="isEn" src="@/assets/word.png" width="450" />
        <img v-else src="@/assets/word2.png" width="450" />
      </div>
      <a-icon style="font-size: 50px;color: #00023d;margin-right: 40px" type="menu" @click="show = true" />
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
export default {
  name: 'acnHead',
  data () {
    return {
      selectedKeys: [this.$route.path],
      show: false
    }
  },
  computed: {
    ...mapGetters(['locale', 'pc', 'isEn'])
  },
  methods: {
    ...mapMutations(['setLocale']),
    select (value) {
      localStorage.setItem('locale', value)
      this.setLocale(value)
      this.$i18n.locale = value
      this.show = false
    },
    home () {
      this.show = false
      this.$router.push('/home')
    }
  },
  watch: {
    $route ({ path }) {
      if (path === '/countryInfo') {
        this.selectedKeys = ['/country']
      } else {
        this.selectedKeys = [path]
      }
    }
  }
}
</script>

<style lang="less">
  .acn_head {
    display: flex;
    height: 150px;
    position: relative;
    justify-content: center;

    .logo {
      position: absolute;
      left: -13px;
      top: 12px;
    }

    .menu {
      background: transparent;
      border: 0 !important;
      line-height: 26px;

      li {
        font-size: 18px;
        top: 104px !important;
        padding: 0;
        margin: 0 12px;
      }
    }

    .ant-select-selection {
      border: 0 !important;
      box-shadow: none !important;
    }

    .ant-select-selection-selected-value {
      padding-right: 0;
    }
  }

  .ant-select-dropdown-menu-item:hover {
    background: #F2F2F2 !important;
  }
  .ant-select-dropdown-menu-item-active {
    background: #F2F2F2 !important;
  }
  .ant-select-arrow {
    color: rgba(0, 0, 0, 0.65) !important;
  }

  .pen {
    pointer-events: none;
  }
</style>
